const wizardReducer = (state={}, action) => {
    switch (action.type){
        case 'SET_ASSISTENTE':{
            let newState = {...state}
            newState.assistente = action.assistente
            return state = newState;
        }
        case 'SET_STATE_ASSISTENTE':{
            let newState = {...state}
            newState[action.id] = action.stateAssistente
            return state = newState;
        }
        case 'DELETE_ASSISTENTE':{
            return state = {};
        }
        case 'SET_FLAG_INSERIMENTO_MANUALE':{
            let newState = {...state}
            newState.flagInserimentoManuale = action.flagInserimentoManuale
            return state = newState;
        }

        default : return state
    }
}

export default wizardReducer
